const getDataUrlFromBlob = async (blobOrUrl, isSvg) => {
  let downloadedBlob
  if (isSvg) {
    const response = await fetch(blobOrUrl)
    const data = await response.arrayBuffer()
    downloadedBlob = new Blob([data], { type: 'image/svg+xml' })
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = event => resolve(event.target.result)
    reader.onerror = reject
    reader.readAsDataURL(isSvg ? downloadedBlob : blobOrUrl)
  })
}

export default getDataUrlFromBlob
